import { isEmpty } from '@/helpers/object'

const getLocationArray = object => Object.keys(object).map(id => ({ id, ...object[id] }))

export default {
  namespaced: true,
  state: {
    currentCountryIso: '',
    countries: [],
    currentCountryStates: [],
  },

  getters: {
    currentCountry: state => state.countries.find(({ iso }) => iso === state.currentCountryIso),
    currentCountryId: (state, getters) => {
      const country = getters.currentCountry
      return !isEmpty(country) ? country.id : -1
    },
    getCountryById: state => countryId => state.countries.find(({ id }) => id === countryId),
  },

  mutations: {
    setCurrentCountryIso(state, countryIso) {
      state.currentCountryIso = countryIso
    },
    setCountries(state, countries) {
      state.countries = countries
    },
    setCurrentCountryStates(state, countryStates) {
      state.currentCountryStates = countryStates
    },
  },

  actions: {
    handleFetchData({ commit }, { territories, currentCountryIso }) {
      commit('setCurrentCountryIso', currentCountryIso)
      commit('setCountries', getLocationArray(territories.countries))
      commit('setCurrentCountryStates', getLocationArray(territories.states))
    },
  },
}
